module.exports = __webpack_public_path__ + "img/message-circle-01.5dca8ee4.svg";